import { render, staticRenderFns } from "./BmControlPedido.vue?vue&type=template&id=0ae98350&"
import script from "./BmControlPedido.vue?vue&type=script&lang=js&"
export * from "./BmControlPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports